import Image from 'next/image'
import './anotation.scss'

interface AnotationProps {
    text: string
}

export const Anotation = ({ text }: Readonly<AnotationProps>) => {

    return (
        <div className='anotation' data-testid='anotation-container' id='anotation-container'>
            <Image
                className='anotation__icon'
                src={`${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/icon/icon-information.svg`}
                alt="Ícone de Informação"
                width={24}
                height={24}
                data-testid='anotation-icon'
                id='anotation-icon'
            />
            <p className='anotation__text' data-testid='anotation-text' id='anotation-text'>{text}</p>
        </div>
    )
}